module.exports = __webpack_public_path__ + "assets/hostel-world-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/hostel-world-logo.png
// module id = 1208
// module chunks = 7